export const useFieldTranslator = {
  methods: {
    getTranslatedAchievementType(value) {
      const types = {
        system: "Системное",
        custom: "Пользовательское",
      };
      return types[value];
    },
    getTranslatedStatus(logicalValue = false) {
      return logicalValue ? "Успех" : "Провал";
    },
    getTranslatedSubtype(recordValue = "cloth") {
      const translatedValues = {
        cloth: "Ткань",
        sewing_accessory: "Фурнитура",
        product: "Продукт",
        cut_of_clothes: "Крой",
        stationery: "Канцелярия",
        expendable_material: "Расходник",
        promotional_product: "Рекламная продукция",
        package: "Упаковка",
      };
      return translatedValues[recordValue];
    },
  },
};



// WEBPACK FOOTER //
// ./src/_shared/mixins/useFieldTranslator.js